import React from 'react';
import { Link, match } from 'react-router-dom';
import { connect } from 'react-redux';
import { HttpStateLine } from 'state-line';
import Container from 'xgimi-ui/Container';
import LoadingContainer from 'xgimi-ui/LoadingContainer';
import images from '../../../assets/images';
import s from './.module.scss';
import Api from '../../../api';
import List from '../History/List';

import StoreComponent, { mapStateToProps } from '../../../appComponents/Store';

interface Props {
  match: match<{
    // 反馈编号
    feedbackNo: string;
  }>;
}
interface State{
  isGettingHistoryDetail:boolean;
  historyDetail:Record<string, any>[];
}

/**
 * 反馈详情页
 */
class Component extends StoreComponent<Props, State> {
  state: State = {
    isGettingHistoryDetail: false,
    historyDetail: [],
  };
  constructor(props: Props) {
    super(props, { title: '反馈详情' });
  }
  componentDidMount() {
    this.getDetail();
  }

  /**
   * 获取反馈详情
   */
  private getDetail = async (): Promise<void> => {
    this.setState({ isGettingHistoryDetail: true });
    const httpStateLine = await new HttpStateLine(new Api.feedback.GetDetail({
      feedbackNo: this.props.match.params.feedbackNo,
    })).run().catch(() => null);
    if (httpStateLine) {
      const historyDetail: Record<string, any>[] = [];
      historyDetail.push(httpStateLine?.result?.data);
      this.setState({ historyDetail });
      this.setState({
        historyDetail,
        isGettingHistoryDetail: false,
      });
    }
  };
  render():React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        <LoadingContainer
          isLoading={this.state.historyDetail.length === 0 && this.state.isGettingHistoryDetail}
          isData={this.state.historyDetail.length > 0}
          message={''}
          messageComponent={(
            <div className={s.top}>
              <img src={images.emptyHistory} alt="success" className={s.image}/>
              <div className={s.empty}>{this.t('historyEmpty')}</div>
              <div className={s.thank}>{this.t('welcome')}</div>
              <Link to={`/feedback${window.location.search}`} className={s.gotoFeed}>
                {this.t('gotoFeed')}
              </Link>
            </div>
          )}
        >
          <List historyList={this.state.historyDetail} isDetail={true} title="反馈详情" />
          {/* 更多 */}
          <div className={s.more}>
            <Link to={'/feedback/historyMore'}>查看更多历史反馈</Link>
          </div>
        </LoadingContainer>
      </Container>
    );
  }
}
export default connect(mapStateToProps)(Component);
